﻿

(() => {
    angular.module('fliptoWeb')
        .constant('events', {
        progressUpdated: 'progress_updated',
        currentStepUpdated: 'step_updated',
        ratingUpdated: 'rating_updated',
        quoteUpdated: 'quote_updated',
        photoUpdated: 'photo_updated',
        shareUpdated: 'share_updated'
    })
})()
 